import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty,
  CommandGroup, CommandItem,
} from "@/components/ui/command";
import { api } from "@/lib/api";
import {
  Home, Users, Gauge, FileSignature, Receipt,
  CreditCard, MessageSquare, BarChart3, Settings, User as UserIcon,
} from "lucide-react";

export default function CommandPalette({ open, onOpenChange }) {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState({ customers: [] });

  useEffect(() => {
    if (!open) { setQuery(""); setResults({ customers: [] }); return; }
  }, [open]);

  useEffect(() => {
    const t = setTimeout(async () => {
      if (query.length < 2) { setResults({ customers: [] }); return; }
      try {
        const { data } = await api.get(`/customers?q=${encodeURIComponent(query)}&limit=6`);
        setResults({ customers: data.items || [] });
      } catch {
        setResults({ customers: [] });
      }
    }, 200);
    return () => clearTimeout(t);
  }, [query]);

  const go = (path) => { onOpenChange(false); navigate(path); };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <div data-testid="command-palette">
        <CommandInput
          placeholder="Søk etter kunder eller hopp til side…"
          value={query}
          onValueChange={setQuery}
          data-testid="command-input"
        />
        <CommandList>
          <CommandEmpty>Ingen treff.</CommandEmpty>
          {results.customers.length > 0 && (
            <CommandGroup heading="Kunder">
              {results.customers.map((c) => (
                <CommandItem
                  key={c.id}
                  value={`kunde-${c.id}-${c.full_name}`}
                  onSelect={() => go(`/kunder/${c.id}`)}
                  data-testid={`command-customer-${c.id}`}
                >
                  <UserIcon className="h-4 w-4 mr-2 text-emerald-400" />
                  <div className="flex items-center gap-2">
                    <span className="text-zinc-100">{c.full_name}</span>
                    <span className="text-[10px] text-zinc-500">{c.customer_number}</span>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          )}
          <CommandGroup heading="Navigasjon">
            <CommandItem onSelect={() => go("/")} value="dashboard">
              <Home className="h-4 w-4 mr-2" /> Dashboard
            </CommandItem>
            <CommandItem onSelect={() => go("/kunder")} value="kunder"><Users className="h-4 w-4 mr-2" /> Kunder</CommandItem>
            <CommandItem onSelect={() => go("/kunder/ny")} value="ny kunde"><Users className="h-4 w-4 mr-2" /> Ny kunde</CommandItem>
            <CommandItem onSelect={() => go("/malepunkter")} value="malepunkter"><Gauge className="h-4 w-4 mr-2" /> Målepunkter</CommandItem>
            <CommandItem onSelect={() => go("/avtaler")} value="avtaler"><FileSignature className="h-4 w-4 mr-2" /> Avtaler</CommandItem>
            <CommandItem onSelect={() => go("/fakturering")} value="fakturering"><Receipt className="h-4 w-4 mr-2" /> Fakturering</CommandItem>
            <CommandItem onSelect={() => go("/betaling")} value="betaling"><CreditCard className="h-4 w-4 mr-2" /> Betaling</CommandItem>
            <CommandItem onSelect={() => go("/saker")} value="saker"><MessageSquare className="h-4 w-4 mr-2" /> Saker</CommandItem>
            <CommandItem onSelect={() => go("/rapporter")} value="rapporter"><BarChart3 className="h-4 w-4 mr-2" /> Rapporter</CommandItem>
            <CommandItem onSelect={() => go("/innstillinger")} value="innstillinger"><Settings className="h-4 w-4 mr-2" /> Innstillinger</CommandItem>
          </CommandGroup>
        </CommandList>
      </div>
    </CommandDialog>
  );
}
